<script setup lang="ts">
import { defineProps, defineEmits } from "vue";
import ArrowIcon from "@/components/icons/ArrowIcon.vue";
import LoaderIcon from "@/components/icons/LoaderIcon.vue";

const props = defineProps({
  bgColor: {
    type: String,
  },
  hoverBgColor: {
    type: String,
  },
  text: {
    type: String,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits<{
  (e: "click"): void;
}>();
</script>

<template>
  <button
    class="group relative flex items-center justify-between px-1 md:px-2 rounded-full text-white font-sf text-[18px] leading-[24px] font-medium overflow-hidden transition-colors"
    :class="{
      'opacity-80 pointer-events-none': isLoading || isDisabled,
    }"
    @click="emits('click')"
  >
    <!-- Text -->
    <LoaderIcon v-if="isLoading" />
    <span
      v-if="!isLoading && text"
      class="z-10 w-full text-center font-semibold text-sm leading-[21px] md:font-medium md:text-base md:leading-100p"
    >
      {{ props.text }}
    </span>
    <!-- Arrow Icon -->
    <slot name="icon">
      <span
        class="min-h-[38px] min-w-[38px] md:min-h-[46px] md:min-w-[46px] flex items-center justify-center rounded-full bg-white transition-transform z-10 ml-auto"
      >
        <ArrowIcon
          class="text-brown group-hover:text-active transition-transform duration-300 ease-in-out group-hover:rotate-45"
        />
      </span>
    </slot>
    <!-- Button Backgrounds -->
    <span
      class="absolute inset-0 transition-opacity duration-300 ease-in-out group-hover:opacity-0"
      :class="props.bgColor"
    ></span>
    <span
      class="absolute inset-0 opacity-0 transition-opacity duration-300 ease-in-out group-hover:opacity-100"
      :class="props.hoverBgColor"
    ></span>
  </button>
</template>
